import styled, { css } from 'styled-components';

import { alignMiddle } from '../../styles/utils/positioning';

export const ScrollableContainer = styled.div<{ $maxHeight: string }>`
  overflow-y: auto;
  max-height: ${({ $maxHeight }) => $maxHeight};
`;

export const SearchInpBlock = styled.div`
  padding: 13px 15px;
  border-bottom: 5px solid ${({ theme }) => theme.black.a1};
`;

export const SearchContent = styled.div`
  > div:last-child > div:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 0;
  }
`;

export const SectionBox = styled.div`
  min-height: 56px;
  position: relative;
`;

export const ItemPlaceholder = styled.div`
  font-size: 1rem;
  padding: 17px 15px;
`;

export const OptItem = styled.div<{ $multiSelect?: boolean; $disabled?: boolean }>`
  ${({ theme, $multiSelect, $disabled }) => css`
    font-size: 1rem;
    cursor: pointer;
    border-bottom: 1px solid ${theme.black.a1};
    position: relative;
    opacity: ${$disabled ? '0.4' : '1'};
    pointer-events: ${$disabled ? 'none' : 'unset'};

    &:hover,
    &.cur,
    &.checked:hover {
      color: ${theme.white.a10};
      background-color: ${theme.baseBlue.a10};
      .iconCheckbox svg {
        stroke: ${theme.baseBlue.a3};
      }
      .label {
        color: ${theme.white.a10};
      }
    }

    &:hover .avatar-box {
      display: ${$multiSelect ? 'none' : 'block'};
    }

    &.checked {
      background-color: ${theme.black.a0};
      .avatar-box {
        display: none;
      }
    }

    .avatar-box {
      position: absolute;
      left: 15px;
      ${alignMiddle}
    }

    label {
      padding: 17px 15px 17px 23px;

      .label {
        margin-left: 23px;
      }
    }
  `}
`;

export const ItemTitle = styled.div<{ $withAvatar?: boolean }>`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 17px 15px;
  padding-left: ${({ $withAvatar }) => ($withAvatar ? '23' : '15')}px;
`;
